module.exports = __webpack_public_path__ + "img/testimonials-bg.8aa16d40.png";